export default __webpack_public_path__ + "static/media/Service2.e1988e97.png";